import { Global } from '@emotion/react';
import { Route, Routes } from 'react-router-dom';
import tw, { css } from 'twin.macro';

import ErrorBoundary from './components/ErrorBoundary';
import Retirement from './views/Retirement';

export default function App() {
  return (
    <>
      <Global
        styles={css`
          :root {
            color-scheme: light;
          }

          html {
            ${tw`min-h-full bg-white`}
            font-size: 100%;
            scroll-behavior: smooth;
          }

          body {
            ${tw`m-0 min-h-screen bg-white font-sans text-base antialiased`}
          }

          #root {
            ${tw`min-h-screen`}
          }

          * {
            scrollbar-color: #94a3b8 #e9e6df;
            scrollbar-width: thin;
          }

          *::selection {
            background: #c7d2fe;
            color: #1e1b4b;
          }

          button,
          summary {
            -webkit-tap-highlight-color: transparent;
          }

          @media (prefers-reduced-motion: reduce) {
            html {
              scroll-behavior: auto;
            }
          }
        `}
      />
      <ErrorBoundary>
        <Routes>
          <Route path="*" element={<Retirement />} />
        </Routes>
      </ErrorBoundary>
    </>
  );
}
